import { CurrentUserService } from '@/app/common/current-user/current-user.service';
import { TooltipDirective } from '@/app/common/directives/tooltip/tooltip.directive';
import { ScreeningListResponseDto } from '@/app/common/general-types/social-screening.dto';
import { SocialScreeningService } from '@/app/services/social-screening/social-screening.service';
import { Component, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'mon-creator-lists',
  imports: [TooltipDirective],
  templateUrl: './creator-lists.html',
  styleUrl: './creator-lists.css',
})
export class CreatorLists implements OnInit {

  /** Creator Lists */
  allLists = signal<ScreeningListResponseDto[]>([]);
  /** Creator Lists - END */

  /** Services */
  private router = inject(Router);
  private socialScreeningService = inject(SocialScreeningService);
  private currentUserService = inject(CurrentUserService);
  /** Services - END */ 

  ngOnInit(): void {
    this.getSocialScreeningLists();
  }

  getSocialScreeningLists() {
    this.socialScreeningService.getBusinessAccountSocialScreeningLists(this.currentUserService.focussedBrand.id).subscribe((response) => {
      console.log('Social Screening Lists:', response);
      this.allLists.set(response as ScreeningListResponseDto[]);
    });
  }

  getCreatorCount(list: ScreeningListResponseDto): number {
    return list.creators?.length ?? 0;
  }

  formatListDate(list: ScreeningListResponseDto): string {
    const raw = list.createdDate as Date | string | undefined;
    if (raw == null) {
      return '—';
    }
    const dateObj = raw instanceof Date ? raw : new Date(raw);
    if (Number.isNaN(dateObj.getTime())) {
      return '—';
    }
    return new Intl.DateTimeFormat('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    }).format(dateObj);
  }

  /** Next step route TBD */
  goToListDetails(list: ScreeningListResponseDto): void {
    // e.g. this.router.navigate([...], { queryParams: { listId: list.id } });
    console.log('goToListDetails()', list);
    this.router.navigate(['/creator-list-details', list.id]);
  }
}
